import { render, staticRenderFns } from "./DataTableJSONPage.vue?vue&type=template&id=b3b22fd2&"
import script from "./DataTableJSONPage.vue?vue&type=script&lang=js&"
export * from "./DataTableJSONPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports